<template>
    <div class="page-container thank-you">
        <div v-if="error">
            <h2>{{error.message}}.</h2>
        </div>
        <div v-else-if="paymentIntent && paymentIntent.status === 'processing'">
          <h2>Payment needs to be confirmed.</h2>
        </div>
        <div v-else-if="paymentIntent && paymentIntent.status === 'succeeded' || !paymentIntent">
          <span class="success-icon-wrapper">
            <img src="images/Check-2.svg" class="success-icon"/>
          </span>
          <h2>Thank you for your purchase!</h2>
          <h3>Your payment has been confirmed</h3>
          <p>A confirmation email will be sent to your email address</p>
          <button class="button pink full-width payment-button" type="submit" @click="goToHome">Return to the app</button>
        </div>
        <div v-else>
          <h2>Your payment failed.</h2>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

import Loader from "../common/loader.vue";

export default {
  components: {
    Loader,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
        paymentIntent: 'checkout/getStripePaymentIntent',
        error: 'checkout/getStripeError',
    })
  },
  mounted() {
  
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    }
  }
};
</script>